import React from "react";
import PropTypes from "prop-types";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { GetAgentBookingCancellationStatusDescription } from "enums/AgentBookingCancellationStatus.js";
import { formatDateTime } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function View(props) {
  const { agentBookingCancellation, history, currency } = props;
  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              AGENT BOOKING CANCELLATION DETAILS
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => history.goBack()} value="Back">
              BACK
            </Button>
            <CustomInput
              labelText="Cancellation No"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                disabled: true,
                value: agentBookingCancellation.no
              }}
            />
            <CustomInput
              labelText="Agent"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                disabled: true,
                value: agentBookingCancellation.agent.name
              }}
            />
            <CustomInput
              labelText="Booking No"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                disabled: true,
                value: agentBookingCancellation.booking.no
              }}
            />
            <CustomInput
              labelText="Reason"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                disabled: true,
                value: agentBookingCancellation.reason
              }}
            />
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Currency"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    disabled: true,
                    value: currency
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Refund Amount"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    disabled: true,
                    value: agentBookingCancellation.refundAmount.toLocaleString()
                  }}
                />
              </GridItem>
            </GridContainer>
            <CustomInput
              labelText="Status"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                disabled: true,
                value: GetAgentBookingCancellationStatusDescription(
                  agentBookingCancellation.status
                )
              }}
            />
            {agentBookingCancellation.status === 0 && (
              <CustomInput
                labelText="Created At"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  disabled: true,
                  value: formatDateTime(
                    new Date(agentBookingCancellation.transactionTime + "Z")
                  )
                }}
              />
            )}
            {agentBookingCancellation.status === 1 && (
              <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Submitted At"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatDateTime(
                        new Date(agentBookingCancellation.submittedAt + "Z")
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Submitted By"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: agentBookingCancellation.submittedBy
                    }}
                  />
                </GridItem>
              </GridContainer>
            )}
            {agentBookingCancellation.status === 2 && (
              <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Approved At"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatDateTime(
                        new Date(agentBookingCancellation.approvedAt + "Z")
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Approved By"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: agentBookingCancellation.approvedBy
                    }}
                  />
                </GridItem>
              </GridContainer>
            )}
            {agentBookingCancellation.status === 3 && (
              <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Rejected At"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: formatDateTime(
                        new Date(agentBookingCancellation.rejectedAt + "Z")
                      )
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Rejected By"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: agentBookingCancellation.rejectedBy
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Rejected Reason"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: agentBookingCancellation.rejectedReason
                    }}
                  />
                </GridItem>
              </GridContainer>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

View.propTypes = {
  agentBookingCancellation: PropTypes.object,
  history: PropTypes.object,
  currency: PropTypes.string
};
